import { useEffect, useState } from 'preact/hooks';

const BASE_DPR = Math.max(1, Math.floor(globalThis.devicePixelRatio ?? 1));

export function useZoomScale() {
  const [scale, setScale] = useState(getScale);

  useEffect(() => {
    function updateZoomScale() {
      setScale(getScale());
    }

    window.visualViewport?.addEventListener('resize', updateZoomScale);

    return () => {
      window.visualViewport?.removeEventListener('resize', updateZoomScale);
    };
  }, []);

  return scale;
}

function getScale() {
  if (import.meta.env.SSR) {
    return 1;
  }

  if (window.visualViewport?.scale && window.visualViewport.scale !== 1) {
    return window.visualViewport.scale; // pinch zoom
  }

  return window.devicePixelRatio / BASE_DPR; // zoom (CMD+ or CTRL+)
}
